/**
 * Web stub: the showcase has no native AdMob SDK, so the App Open ad is a no-op.
 * Metro resolves this `.web` file on web, so the native module is never bundled
 * for the browser build.
 */
export async function initAppOpenAd(): Promise<void> {
  // No native ads on web.
}
